import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faHome,
	faUsers,
	faPaste,
	faCreditCard,
	faMobileScreenButton
} from '@fortawesome/free-solid-svg-icons';
import { Stack } from '@mui/material';

import { getRuta, isAccess } from '../../helpers/Helpers';
import { DataContext } from '../../context/DataContext';
import { ItemNav } from './ItemNav';
import { Configurations } from './Configurations';
import Security from './Security';
import Nomina from './Nomina';

const NavLinks = ({ drawerIsOpen }) => {
	let rout = getRuta();
	const { access } = useContext(DataContext);

	return (
		<nav aria-label="Menú principal" style={{ overflow: 'hidden' }}>
			<Stack spacing={0.25} padding={1} justifyContent="flex-start">
				{/* Home */}
				<ItemNav
					to={`${rout}/`}
					end
					icono={<FontAwesomeIcon icon={faHome} fixedWidth />}
					texto="Panel Principal"
					drawerIsOpen={drawerIsOpen}
				/>

				{/* Clients */}
				{isAccess(access, 'CLIENTS VER') ? (
					<ItemNav
						to={`${rout}/clients`}
						icono={<FontAwesomeIcon icon={faUsers} fixedWidth />}
						texto="Clientes"
						drawerIsOpen={drawerIsOpen}
					/>
				) : (
					<></>
				)}

				{/* Credits */}
				{isAccess(access, 'CREDITS VER') ? (
					<ItemNav
						to={`${rout}/credits`}
						icono={<FontAwesomeIcon icon={faCreditCard} fixedWidth />}
						texto="Créditos"
						drawerIsOpen={drawerIsOpen}
					/>
				) : (
					<></>
				)}

				{/* Nomina */}
				{isAccess(access, 'NOMINA VER') ? <Nomina drawerIsOpen={drawerIsOpen} /> : <></>}

				{/* Reports */}
				{isAccess(access, 'REPORTS VER') ? (
					<ItemNav
						to={`${rout}/reports`}
						icono={<FontAwesomeIcon icon={faPaste} fixedWidth />}
						texto="Reportes"
						drawerIsOpen={drawerIsOpen}
					/>
				) : (
					<></>
				)}

				{/* Security */}
				{isAccess(access, 'SECURITY VER') ? <Security drawerIsOpen={drawerIsOpen} /> : <></>}

				{/* Configuration */}
				{isAccess(access, 'CONFIG VER') ? (
					<Configurations drawerIsOpen={drawerIsOpen} />
				) : (
					<></>
				)}

				{/* Pagina publica de descarga de la app Android (la sirve el servidor, fuera de
				    la SPA). Sin permiso: cualquiera puede necesitar pasarle el enlace a un gestor. */}
				<ItemNav
					href="/descargar"
					icono={<FontAwesomeIcon icon={faMobileScreenButton} fixedWidth />}
					texto="Descargar App"
					drawerIsOpen={drawerIsOpen}
				/>
			</Stack>
		</nav>
	);
};

export default NavLinks;
